import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as detailTruckActions from '../../actions/detail_truck/index';

/* Components */
import Header from '../../components/detail_truck/header';
import DistributionGraph from '../../components/detail_truck/distributionGraph';
import RankingTable from '../../components/detail_truck/rankingTable';
import MainInspection from '../../components/detail_truck/mainInspection';
import GravityPie from '../../components/detail_truck/gravityPie';
import FailsGravity from '../../components/detail_truck/failsPie';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import TableTile from '../../components/detail_truck/tableTitle';
import moment from 'moment';

class DetailTruck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      select: '',
      rankingType: 'vehicle',
      formSeverity: 0,
      formLabel: 'Todos',
      severity: 'Todas',
      gravity: {
        Todas: 0,
        LEVE: 1,
        MODERADA: 2,
        GRAVE: 3,
        GRAVÍSIMA: 4
      }
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleQuestion = this.handleQuestion.bind(this);
    this.handleRankingFilter = this.handleRankingFilter.bind(this);
    this.handleFormRequest = this.handleFormRequest.bind(this);
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('form');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('form')) {
          this.props.actions.fetchDetailRankingApi({ type: this.state.rankingType });
          this.props.actions.fetchDetailTruckApi({});
          this.props.actions.fetchDetailQuestionApi({
            severityType: this.state.gravity[this.state.severity]
          });
          this.props.actions.fetchFilterApi({});
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  /* test handle submit ranking */
  handleQuestion(e) {
    e.preventDefault();
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags({ id: null });
    /* DATE */
    const date = ObjGeneral.getDate({ id: null }, format);

    this.setState({ ...this.state, severity: e.target.getAttribute('data-type') }, () => {
      this.props.actions.fetchDetailQuestionApi({
        tags,
        date,
        severityType: this.state.gravity[this.state.severity]
      });
    });
  }

  /* Function filter date and tags */
  handleSubmit = async obj => {
    /* GROUP */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);
    /* RISK */

    await this.props.actions.fetchDetailTruckApi({
      tags,
      date
    });

    this.props.actions.fetchDetailRankingApi({ tags, date, type: this.state.rankingType });

    this.props.actions.fetchDetailQuestionApi({
      tags,
      date,
      severityType: this.state.gravity[this.state.severity]
    });
  };

  /* Handle form detatail question request */
  handleFormRequest(e) {
    e.preventDefault();
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags({ id: null });
    /* DATE */
    const date = ObjGeneral.getDate({ id: null }, format);

    this.setState(
      {
        ...this.state,
        formSeverity: e.target.getAttribute('data-value'),
        formLabel: e.target.getAttribute('data-type')
      },
      () => {
        this.props.actions.fetchDetailQuestionApi({
          tags,
          date,
          severityType: this.state.formSeverity
        });
      }
    );
  }

  /* Function for ranking table filter */
  handleRankingFilter(e) {
    e.preventDefault();
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags({ id: null });
    /* DATE */
    const date = ObjGeneral.getDate({ id: null }, format);

    this.setState({ ...this.state, rankingType: e.target.getAttribute('data-type') }, () => {
      this.props.actions.fetchDetailRankingApi({
        tags,
        date,
        type: this.state.rankingType
      });
    });
  }

  /* Function for fiter date and tags */

  render() {
    const item = this.props.datos ? this.props.datos.datos.response : [];
    const tableData = this.props.datos ? this.props.datos.rankingData.data.ranking : [];
    const toolTip = this.props.language.detail_fatigue
      ? this.props.language.detail_fatigue.graphToolTip
      : '';

    if (this.props.setting) {
      const lang = localStoreFN().getItem('lang');
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.summaryTruck,
        filter: this.props.filter,
        general: obj.generalSetting
      });

      const evolutionScore = this.props.datos
        ? this.props.datos.datos.response
          ? this.props.datos.datos.response.evolutionScore
          : []
        : [];

      const { graphColorRange } = obj;
      const severityFails = item ? (item.severityFails ? item.severityFails : []) : [];
      const severityFailsColor = obj.form.severityFailsColor;
      const languageFormat = lang;
      const tagType = item ? (item.tagType ? item.tagType.replace(/['"]+/g, '') : '') : '';
      const averageScore = item ? item.averageScore.actual.value : '';
      const trend = item ? item.averageScore.trend : '';
      const differenceValue = item ? item.averageScore.differenceValue : '';
      const fails = this.props.datos.datos.response ? this.props.datos.datos.response.fails : '';
      const questionFailsData = this.props.datos
        ? this.props.datos.questionData.data.questionFails
        : [];
      const existentFails = this.props.datos ? this.props.datos.filters.data.existentFails : [];
      const formTypes = this.props.datos ? this.props.datos.filters.data.existentForms : [];
      const language = this.props.language ? this.props.language : '';
      const averagescore = this.props.datos ? this.props.datos.datos.response : '';

      /* main inspection tooltip date */
      const actualDate = averagescore ? averagescore.averageScore.actual.end : '';
      const previousDate = averagescore ? averagescore.averageScore.actual.start : '';
      const actualValue = averagescore ? averagescore.averageScore.actual.value : '';

      let previousDateStart = averagescore ? averagescore.averageScore.previous.start : '';
      let previousDateEnd = averagescore ? averagescore.averageScore.previous.end : '';
      let previousValue = averagescore ? averagescore.averageScore.previous.value : '';

      previousDateStart = moment(previousDateStart.substring(0, 10)).format('DD/MM');
      previousDateEnd = moment(previousDateEnd.substring(0, 10)).format('DD/MM');

      const dateBefor = moment(previousDate.substring(0, 10)).format('DD/MM');
      const dateNow = moment(actualDate.substring(0, 10)).format('DD/MM');
      /* main inspection tooltip date */

      /* fallas tooltip date */
      let previousFailStartDate = fails.previous ? fails.previous.start : '';
      let previousFailsEndtDate = fails.previous ? fails.previous.end : '';
      let previousFailsValue = fails.previous ? fails.previous.value : '';

      let actualFailStartDate = fails.actual ? fails.actual.start : '';
      let actualFailsEndtDate = fails.actual ? fails.actual.end : '';
      let actualFailsValue = fails.previous ? fails.actual.value : '';

      let failsdiferentValue = fails.differenceValue;

      previousFailStartDate = moment(previousFailStartDate.substring(0, 10)).format('DD/MM');
      previousFailsEndtDate = moment(previousFailsEndtDate.substring(0, 10)).format('DD/MM');

      actualFailStartDate = moment(actualFailStartDate.substring(0, 10)).format('DD/MM');
      actualFailsEndtDate = moment(actualFailsEndtDate.substring(0, 10)).format('DD/MM');
      /* fallas tooltip date */

      /* table toolltip date */

      /* table toolltip date */

      return (
        <section className="main">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            handleSubmit={this.handleSubmit}
            language={language}
            select={this.state.select}
            date={this.props.dateMax[0]}
          />

          <div className="main-container">
            {this.props.generalLoading ||
            this.props.rankingLoading ||
            this.props.questionLoading ? (
              <Loading />
            ) : this.props.generalStatus === 200 &&
              this.props.rankingStatus === 200 &&
              this.props.QuestionStatus == 200 ? (
              <div className="new-detail-container">
                {/* top-line-grid*/}
                <div className="top-line-grid">
                  <div className="test-vh">
                    <MainInspection
                      tagType={tagType}
                      item={item}
                      averageScore={averageScore}
                      trend={trend ? trend : 0}
                      differenceValue={differenceValue}
                      dateActual={{ dateBefor, dateNow, actualValue }}
                      datePrevious={{ previousDateStart, previousDateEnd, previousValue }}
                      languague={this.props.language}
                    />
                  </div>
                  <div className="right-col-container">
                    {evolutionScore.length !== 0 ? (
                      <div className="new-distribution">
                        <div className="distribution-heading">
                          <h2>Evolucion diaria nota inspecciones</h2>
                        </div>
                        <DistributionGraph
                          language={toolTip}
                          graphColorRange={graphColorRange.fatigueRiskPercentage}
                          data={evolutionScore}
                          notaInspecciones={averageScore}
                          id="test1"
                        />
                        <Tooltip placement="top" id="pageTooltip" />
                      </div>
                    ) : (
                      <div className="new-distribution">
                        <div className="distribution-heading no-data-hd">
                          <h2>Evolucion diaria nota inspecciones</h2>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* top-line-grid */}
                </div>
                {/* bottom-line-grid */}
                <div className="bottom-line-grid">
                  <div className="table-ranking-wraper">
                    <TableTile
                      handleRanking={this.handleRankingFilter}
                      rankingLabel={this.state.rankingType}
                    />
                    <div className="new-ranking">
                      <RankingTable
                        rankingLabel={this.state.rankingType}
                        language={this.props.language}
                        size={65}
                        max={200}
                        value={20}
                        data={tableData}
                        graphColorRange={{
                          outOfRisk: [0, null]
                          //  middleRisk: [40, 60],
                          // higherRisk: [60, null]
                        }}
                      />
                    </div>
                  </div>
                  <div className="fails-wraper">
                    <div className="new-pie-container">
                      <div className="pie-heading">
                        <h2>Principales fallas</h2>
                      </div>
                      {/* pie one */}

                      <GravityPie
                        fails={fails}
                        item={item}
                        language={this.props.language}
                        obj={obj}
                        severityFails={severityFails}
                        languageFormat={languageFormat}
                        failsDate={{
                          previousFailStartDate,
                          previousFailsEndtDate,
                          previousFailsValue,
                          failsdiferentValue
                        }}
                        failsDateActual={{
                          actualFailStartDate,
                          actualFailsEndtDate,
                          actualFailsValue
                        }}
                      />

                      {/*pie one*/}

                      {/*pie two*/}
                      <div className="bd-top">
                        <FailsGravity
                          fails={fails}
                          item={item}
                          severityFails={severityFails}
                          questionFailsData={questionFailsData}
                          languageFormat={languageFormat}
                          severityFailsColor={severityFailsColor}
                          gravity={existentFails}
                          obj={obj}
                          handleClik={this.handleQuestion}
                          handleFormClick={this.handleFormRequest}
                          label={this.state.formLabel}
                          form={formTypes}
                          severity={this.state.severity}
                          languague={this.props.language}
                        />
                      </div>

                      {/* pie two */}
                    </div>
                  </div>
                </div>
                {/* bottom-line-grid */}
              </div>
            ) : this.props.generalStatus === 500 &&
              this.props.rankingStatus === 500 &&
              this.props.QuestionStatus == 500 ? (
              <Message message={this.props.language.error.apiError500} />
            ) : (
              <Message message={this.props.language.error.apiError} />
            )}
          </div>
        </section>
      );
    }
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  /* data for testing the view */
  loadingFilter: state.reducer.tags.loading,
  datos: state.reducer.detailTruck,
  ranking: state.reducer.detailTruck,
  filter: state.reducer.tags.filter,
  filters: state.reducer.detailFatigue.filters,
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  /* data for testing the view */

  generalLoading: state.reducer.detailTruck.loading,
  rankingLoading: state.reducer.detailTruck.rankingData.loadingRanking,
  questionLoading: state.reducer.detailTruck.questionData.loadingQuestion,
  generalStatus: state.reducer.detailTruck.status,
  rankingStatus: state.reducer.detailTruck.rankingData.status,
  QuestionStatus: state.reducer.detailTruck.questionData.status
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detailTruckActions, dispatch)
});

DetailTruck.propTypes = {
  setting: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  datos: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  dateMax: PropTypes.oneOfType([PropTypes.array]).isRequired,
  loadingFilter: PropTypes.bool.isRequired,
  filters: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailTruck);



// WEBPACK FOOTER //
// ./source/client/containers/detail_truck/index.jsx